import Table from "../../componentsTable/TanStackTable";
import {DataContext} from '../../../context/DataContext'
import {petitions} from '../../../api/calls'
import { useForm } from "react-hook-form";
import { useEffect, useState,useContext, useRef } from 'react'
import { toast } from "sonner";
import Swal from "sweetalert2";
import TableLoad from "../../componentsTools/TableLoad";
import { exportToExcel_v1 } from "../../componentsTools/ExportToExcel";

function Almacen() {
  const {session, idEmpresa } = useContext(DataContext);
  const [almacen, setAlmacen] = useState([])
  const [estAlmacen, setEstAlmacen] = useState(false)
  const [filtering, setFiltering] = useState("");
  const [idAlmacen, setIdAlmacen] = useState("");
  const [load, setLoad] = useState(true)

  const form1 = useForm();
  const form2 = useForm();

  const modalRef = useRef(null);
  const closeModal = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef.current);
    modalInstance.hide();
  };

  const modalRef2 = useRef(null);
  const closeModal2 = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
    modalInstance.hide();
  };

  const columns = [
    {
      header: "Código",
      accessorKey: "idAlmacen",
    },
    {
      header: "Nombre",
      accessorKey: "nombre",
    },
    {
      header: "Dirección",
      accessorKey: "direccion",
    },
    {
      header: "Estado",
      accessorKey: "estado",
      cell: ({ row }) => {
        const value = row.getValue("estado");
        return (
          <span
            className={(value === "S") ? "text-success fw-bold" : "text-danger fw-bold"}
          >
            {(value === "S") ? "🟢" : "🚫"}
          </span>
        );
      },
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
            data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-reference="parent"
          >
            <span className="fas fa-ellipsis-h fs-10"></span>
          </button>
          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item text-info"
              onClick={() => updateEstado(row.original)}
            >
              <span className="text-body-secondary"> {(row.original.estado === "S") ? "Inhabilitar": "Habilitar"} </span>
            </button>
            <div className="dropdown-divider"></div>
            <button
              className="dropdown-item text-info"
              onClick={() => handleUpdate(row.original)}
            >
              Editar
            </button>
            <button
              className="dropdown-item text-danger"
              onClick={() => deleteAlmacen(row.original.idAlmacen)}
            >
              Eliminar
            </button>
          </div>
        </div>
      ),
    }
  ]

  const updateEstado = async (row) => {
    row.estado = (row.estado === "S") ? "N" : "S"
    const response = await petitions.updateAlmacen(idEmpresa(), session().token, row)
    if (response.status === "success") {
      if (response.data) {
        setEstAlmacen(!estAlmacen)
        toast.success("Estado actualizado correctamente"); 
      }
      else{        
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  }

  const handleUpdate = (data) => {
    form2.setValue('nombre',data.nombre,{ shouldValidate: true })
    form2.setValue('direccion',data.direccion,{ shouldValidate: true })
    setIdAlmacen(data.idAlmacen)
    const modal = new window.bootstrap.Modal(modalRef2.current);
    modal.show();
  }

  const deleteAlmacen = (idAlmacen) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estas seguro/a?",
        text: "No podrás cancelar el proceso",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, eliminar",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const response = await petitions.deleteAlmacen(idEmpresa(), session().token, {idAlmacen,});
          if (response.status === "success") {
            if (response.data) {
              setEstAlmacen(!estAlmacen)
              toast.success("Almacen eliminado correctamente")
            }
            else{
              toast.warning("Ocurrió un problema, inténtelo mas tarde");  
            }            
          } else {
            var msg = typeof response.code === "string" ? response.message : response.data;
            toast.error(msg);
          }
        }
      });
  }

  const sendAlmacen = form1.handleSubmit(async (data) =>{
    data.estado = 'S'
    const response = await petitions.insertAlmacen(idEmpresa(),session().token, data)
    if (response.status === "success") {
      if (response.data) {
        closeModal();
        toast.success("Almacén registrado correctamente");
        setEstAlmacen(!estAlmacen)
        form1.reset(); 
      }
      else{
        closeModal();
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      closeModal();
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  })

  const updateAlmacen = form2.handleSubmit(async (data)=> {
    data.estado = 'S'
    data.idAlmacen = idAlmacen
    const response = await petitions.updateAlmacen(idEmpresa(),session().token, data)
    if (response.status === "success") {
      if (response.data) {
        closeModal2();
        toast.success("Almacén actualizado correctamente");
        setEstAlmacen(!estAlmacen)
        form2.reset(); 
      }
      else{
        setEstAlmacen('')
        closeModal2();
        toast.warning("Ocurrió un problema, inténtenlo mas tarde");
      }
    } else {
      setEstAlmacen('')
      closeModal2();
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  })

  useEffect(() => {
    const fetchAlmacen = async () => {
      setLoad(true);
      const response = await petitions.getAlmacen(idEmpresa(), session().token);
      if (response.status === "success") {
        setAlmacen(response.data);
        setLoad(false);
      } else {
        const msg = typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
        setLoad(false);
      }
    };

    fetchAlmacen();
  }, [estAlmacen, idEmpresa, session]);

  return (
    <>
      <div className="mb-9">
        <div className="row g-2 mb-4">
          <div className="col-auto">
            <h2 className="mb-0">Almacén</h2>
          </div>
        </div>
        <div className="mb-4">
          <div className="row g-10">
            <div className="col-auto">
              <div className="search-box">
                <input
                  className="form-control search-input search rounded-4 border-0 shadow-sm"
                  type="search"
                  placeholder="Buscar almacén"
                  aria-label="Search"
                  value={filtering}
                  onChange={(e) => setFiltering(e.target.value)}
                />
                <span className="fas fa-search search-box-icon"></span>
              </div>
            </div>
            <div className="col-auto">
              <button className="btn btn-link text-body me-4 px-0" onClick={() => exportToExcel_v1(almacen, columns, "Almacen")}>
                <span className="fa-solid fa-file-export fs-9 me-2"></span>
                Exportar
              </button>
              <button
                className="btn btn-primary rounded-4"
                data-bs-toggle="modal"
                data-bs-target="#modalAgregarAlmacen"
              >
                <span className="fas fa-plus me-2"></span>Nuevo almacén
              </button>
            </div>
          </div>
        </div>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
          <div className="table-responsive scrollbar-overlay mx-n1 px-1">
            {load ? (
                <TableLoad />
            ) : (
              <Table
                data={almacen}
                columns={columns}
                filtering={filtering}
                setFiltering={setFiltering}
              />
            )}
          </div>
        </div>
      </div>

      {/* MODALS */}
      <div
        className="modal fade"
        id="modalAgregarAlmacen"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Datos de almacén
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendAlmacen}>
              <div className="modal-body">
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Nombre
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("nombre", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio"
                      },
                      maxLength: {
                        value: 256,
                        message: "Demasiado largo",
                      },
                    })}
                  />
                  {form1.formState.errors?.nombre && (
                    <code>{form1.formState.errors.nombre.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Dirección
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("direccion", {
                      maxLength: {
                        value: 256,
                        message: "Demasiado largo",
                      },
                    })}
                  />
                  {form1.formState.errors?.direccion && (
                    <code>{form1.formState.errors.direccion.message}</code>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalEditarAlmacen"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef2}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Editar almacén
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={updateAlmacen}>
              <div className="modal-body">
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Nombre
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("nombre", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio"
                      },
                      maxLength: {
                        value: 256,
                        message: "Demasiado largo",
                      },
                    })}
                  />
                  {form2.formState.errors?.nombre && (
                    <code>{form2.formState.errors.nombre.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Dirección
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("direccion", {
                      maxLength: {
                        value: 256,
                        message: "Demasiado largo",
                      },
                    })}
                  />
                  {form2.formState.errors?.direccion && (
                    <code>{form2.formState.errors.direccion.message}</code>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Actualizar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default Almacen
